export default [
  {
    name: "Points",
    value: "points"
  }, {
    name: "Offer",
    value: "offer"
  }, {
    name: "None",
    value: "none"
  }
]



/** WEBPACK FOOTER **
 ** ./src/forms/options/promotion.js
 **/